<template>
    <div>
        <label class="v-label theme--light pr-4">{{label}}</label>
        <div>
            <v-card width=110 height=60 @click="change()" class="mb-4 z-clickable">
                <v-row no-gutters>
                    <v-col>
                        <v-img v-if="videokey" :src="$api.getImageUrl(videokey, 200)" height="60px" contain />
                        <v-btn v-else text color="zoezi-edit-color" height="100%" width="100%">{{$translate('Change')}}</v-btn>
                    </v-col>
                    <v-col v-if="videokey">
                        <v-btn class="d-inline-block" icon style="margin-top: 6px" @click.stop="clear" :color="color"><v-icon>mdi-close</v-icon></v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </div>

        <v-dialog
            v-model="showMediaLibrary"
            max-width="80%"
            scrollable
        >
            <v-card>
                <v-card-title class="headline zoezi-edit-color">
                    {{$translate('Choose a video')}}
                    <v-btn icon @click="showMediaLibrary = false" class="ml-auto zoezi-edit-color"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>

                <v-card-text>
                    <div v-if="hint" class="mt-2" v-text="hint" />
                    <media-library :columns="$vuetify.breakpoint.mobile ? 1 : 6" v-model="videokey" v-on:change="changed" type="video" />
                </v-card-text>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import MediaLibrary from './MediaLibrary.vue'
export default {
    name: 'VideoSetting',
    props: ['value', 'label', 'hint'],

    components: {
        MediaLibrary
    },
    data: () => ({
        showMediaLibrary: false,
        videokey: null
    }),
    methods: {
        changed(value) {
            this.showMediaLibrary = false;
            this.$emit('input', value);
            this.videokey = value;
        },
        change() {
            this.showMediaLibrary = true;
        },
        clear() {
            this.changed(null);
        }
    },
    created() {
        this.videokey = this.value;
    }
}
</script>
